module.exports = __webpack_public_path__ + "media/SAF-500_Ares_SocialEngineering_2025.9125b311.mp4";